import { render } from "./Delete.vue?vue&type=template&id=e94f955c"
import script from "./Delete.vue?vue&type=script&lang=js"
export * from "./Delete.vue?vue&type=script&lang=js"

import "./Delete.vue?vue&type=style&index=0&id=e94f955c&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__